import { render, staticRenderFns } from "./PublicacionView.vue?vue&type=template&id=ea84dab4"
import script from "./PublicacionView.vue?vue&type=script&lang=ts"
export * from "./PublicacionView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports